import React from 'react';
import { User } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const CompanyMessageSection = () => {
  const { t } = useLanguage();
  const companyImage = `${process.env.PUBLIC_URL || ''}/company/vision.png`;

  return (
    <section
      id="about"
      className="py-16 bg-gradient-to-br from-blue-50 to-blue-100"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {/* Image block */}
          <div className="fade-in">
            {/* Wrapper có viền + padding + nền xanh */}
            <div className="bg-blue-200 p-2 rounded-lg border border-blue-200">
              <div className="w-full h-64 bg-gradient-to-br from-blue-600 to-blue-500 rounded-md flex items-center justify-center text-white text-xl overflow-hidden">
                {companyImage ? (
                  <img
                    src={companyImage}
                    alt="Company Vision"
                    className="w-full h-full object-cover rounded-md"
                    onError={(e) => {
                      e.currentTarget.style.display = "none";
                      e.currentTarget.nextElementSibling.style.display = "flex";
                    }}
                  />
                ) : null}

                <div
                  className={`${
                    companyImage ? "hidden" : "flex"
                  } items-center justify-center w-full h-full`}
                >
                  <User className="w-16 h-16" />
                </div>
              </div>
            </div>
          </div>

          {/* Text block */}
          <div className="fade-in">
            <h3 className="text-2xl font-medium text-blue-700 mb-4 whitespace-pre-line">
              {t('company.title')}
            </h3>
            <p className="text-gray-700 mb-4 leading-relaxed whitespace-pre-line">
              {t('company.p1')}
            </p>
            <p className="text-gray-700 leading-relaxed whitespace-pre-line">
              {t('company.p2')}
            </p>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CompanyMessageSection;
